import { createStore } from 'vuex';
import axios from 'axios';

interface User {
  id: number;
  numero_compte: number;
  name: string;
  nom: string;
  prenom: string;
  email: string;
  telephone1: number;
  telephone2: number;
  adresse: string;
  date_naissance: null;
  sexe: string;
  type: string;
  poste: string;
  description: string;
  photo: string;
  is_superadmin: boolean;
  is_disabled: boolean;
  raison_sociale: string;
  sigle: string;
  bp: number;
  types_permis: string;
  commercial: string;
  created_at: string;
}

interface State {
  api_url: string;
  authenticated: boolean;
  user: User | null; 
  token: string;
  notificationCount: number;
}

interface AuthPayload {
  user: User;
  token: string;
}

export default createStore({
  state: {
    api_url: 'https://api.logistics.yams-ga.com',
    // api_url: 'http://localhost:9001',
    authenticated: false,
    token: '',
    notificationCount: 0,
    user: null, 
  } as State,
  
  getters: {
    apiUrl: (state: State) => state.api_url,
    user: (state: State) => state.user,
    authenticated: (state: State) => state.authenticated,
    notificationCount: (state: State) => state.notificationCount,
  },
  
  mutations: {
    setUser(state: State, user: User) {
      if (state.user) {
        state.user.nom = user.nom;
        state.user.prenom = user.prenom
        state.user.telephone1 = user.telephone1;
  
        const userDatas = {
          user: state.user,
          token: state.token
        }
        window.localStorage.setItem('espace_yamslogistics_session', JSON.stringify(userDatas))
      }
  },
    setAuthenticated(state: State, payload: AuthPayload) {
      state.user = payload.user;
      state.token = payload.token;
      state.authenticated = true;

      const userDatas = {
        user: payload.user,
        token: payload.token,
      };
      window.localStorage.setItem('espace_yamslogistics_session', JSON.stringify(userDatas));
    },

    setUserPhoto(state: State, photo: string) {
      if (state.user) {
        state.user.photo = photo;
      }

      const userDatas = {
        user: state.user,
        token: state.token,
      };
      window.localStorage.setItem('espace_yamslogistics_session', JSON.stringify(userDatas));
    },

    clearUserData(state: State) {
      state.authenticated = false;
      state.user = null;
      state.token = '';
      window.localStorage.removeItem('espace_yamslogistics_session');
    },

    setNotifications(state: State, nb: number) {
      state.notificationCount = nb;
    },
  },

  actions: {
    async fetchNotifications({ commit, state }) {
      try {
        const response = await axios.get(
          `/api/notifications`
        );
      } catch (error) {
        console.error('Erreur lors de la récupération des notifications:', error);
      }
    },
  },

  modules: {},
});
